function JobCategoriesResearchIcon({ color = "#191515" }) {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.6002 46.2C12.6708 46.2 3.00017 36.5294 3.00017 24.6C3.00017 12.6707 12.6708 3 24.6002 3C36.5295 3 46.2002 12.6707 46.2002 24.6C46.2002 36.5294 36.5295 46.2 24.6002 46.2Z"
        stroke={color}
        stroke-width="5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M57 56.9999L39.8729 39.8711"
        stroke={color}
        stroke-width="5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default JobCategoriesResearchIcon;
